export const ZHHANT = {
  "Open document": "æéææª",
  "Upload file": "ä¸å³æä»¶",
  "Drop file here to upload": "å°æä»¶ææ¾å°æ­¤èä»¥ä¸å³",
  "Disc": "åç¤",
  "URL": "ç¶²å",
  "FILE": "æä»¶",
  "SIZE": "å°ºå¯¸",
  "MB": "MB",
  "KB": "ç¥è­åº«",
  "Bytes": "å­ç¯",
  "Loading... Please wait.": "å è¼è«ç¨åã",
  "Fit Width": "é©åå¯¬åº¦",
  "Fit Height": "é©åé«åº¦",
  "Password protected document": "åå¯ç¢¼ä¿è­·çæä»¶",
  "Password": "å¯ç¢¼",
  "Open": "æé",
  "Password Required": "éè¦å¯ç¢¼",
  "Incorrect password": "å¯ç¢¼é¯èª¤",
  "Error": "é¯èª¤",
  "Something went wrong": "åºäºäºåé¡",
  "Server is not available": "æåå¨ä¸å¯ç¨",
  "of": "ç",
  "Please wait...": "è«ç¨ç­..."
};
